import React, { useEffect } from "react";
import { Header } from "./Header";
import { cn } from "../../utils/cn";
import { useDebugMode } from "../../contexts/DebugModeContext";
import { toast } from "sonner";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function Layout({ children, className }: LayoutProps) {
  const { debugMode, toggleDebugMode } = useDebugMode();

  // Add keyboard shortcut (Ctrl+Shift+D) to toggle debug mode
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === "D") {
        toggleDebugMode();
        // Show a toast notification using Sonner
        toast(debugMode ? "Debug Mode Disabled" : "Debug Mode Enabled", {
          description: debugMode
            ? "Debug tools are now hidden"
            : "Debug tools are now visible on workout cards",
          duration: 2000,
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [debugMode, toggleDebugMode]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className={cn("flex-1", className)}>
        <div className="container py-8 px-4 md:px-8">{children}</div>
      </main>
    </div>
  );
}
